import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getAccountTypeSelected } from '../../features/registration/registrationJourneySlice';
import useTitle from '../../hooks/useTitle';

const PasswordCreated = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const accountTypeSelectedRedux = useSelector(getAccountTypeSelected);
  useTitle(
    'landlordReg.PasswordCreated.s3',
    'You have created a password - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const handleBtnClick = () => {
    if (
      accountTypeSelectedRedux === 'Landlord' ||
      accountTypeSelectedRedux ===
        'Both Property Management Company And Landlord'
    ) {
      history.push('/landlordReg/landlord-type');
    } else {
      history.push('/landlordReg/company-registration-number');
    }
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.PasswordCreated.s1',
          'You have created a password'
        )}
      </h1>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy('landlordReg.PasswordCreated.s2', 'Continue')}
      </Button>
    </>
  );
};

export default PasswordCreated;
